import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { PatchScenarioDto } from '../../types/scenario-modeling.types';
import { useAppMutation } from '../use-app-mutation.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';
import { useRefetchQueries } from '../use-refetch-queries.hook';

export const useUpdate = () => {
  const { invalidateQuery: invalidateViewQueries } = useInvalidateQueries(
    QueryKey.GET_SCENARIO,
    QueryKey.GET_SCENARIO_VESTING_TASKS,
    QueryKey.GET_SCENARIO_VESTING_SARS,
    QueryKey.GET_SCENARIO_GRANTS,
  );

  const { refetchQueries: refetchCalculationQueries } = useRefetchQueries(
    QueryKey.GET_CONVERSION_SUMMARY,
    QueryKey.CALC_CUSTOM_SAFE,
    QueryKey.CALC_SCENARIO_SAFES,
    QueryKey.CALC_SCENARIO_INVESTMENT,
  );

  const { mutate: update, isPending } = useAppMutation([QueryKey.PATCH_SCENARIO], {
    mutationFn: ({ data, scenarioId }: { data: PatchScenarioDto; scenarioId: string }) =>
      ApiService.patch(
        {
          endpoint: BackendRoute.SCENARIOS,
          routePath: [scenarioId],
        },
        {
          body: data,
        },
      ),
    onSuccess: () => {
      refetchCalculationQueries();
      invalidateViewQueries();
    },
  });
  return { update, isPending };
};
